package org.zest.insan_360_website.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.*
import com.varabyte.kobweb.compose.css.*

val standaloneContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth(90.percent)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .maxWidth(500.px)
            .position(Position.Relative)
            .borderRadius(2.cssRem)
            .border {
                width(2.px)
                color(darkGreenColor)
                style(LineStyle.Solid)
            }
            .overflow(Overflow.Hidden)
    }
}

@Composable
fun StandaloneFormContainer(content: @Composable () -> Unit) {
    Box(
        Modifier.fillMaxSize().then(fontSizeBreakpoints.toModifier()),
        contentAlignment = Alignment.Center
    ) {
        Surface(
            standaloneContainerStyle.toModifier()
        ) {
            Column(Modifier.fillMaxWidth()) {
                Box(
                    Modifier
                        .fillMaxWidth()
                        .padding(topBottom = 1.cssRem)
                        .backgroundColor(lightGreenColor)
                        .border {
                            style(LineStyle.Solid)
                            width(top = 0.px, bottom = 2.px, left = 0.px, right = 0.px)
                            color(darkGreenColor)
                        },
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        modifier = Modifier.height(9.cssRem),
                        src = "/images/insan360_logo.webp",
                        description = "Insan 360",
                    )
                }
                Box(Modifier.fillMaxWidth().backgroundColor(Colors.White)) {
                    content()
                }
            }
        }
    }
}
